import { usePageTitle } from '../../hooks/usePageTitle';

interface PageTitleProps {
  dynamicData?: Record<string, string>;
  customTitle?: string;
  customDescription?: string;
}

/**
 * Component that automatically sets the document title based on the current route.
 * Can be used with custom titles or dynamic data for personalized titles.
 */
export const PageTitle: React.FC<PageTitleProps> = ({ dynamicData, customTitle, customDescription }) => {
  usePageTitle({ dynamicData, customTitle, customDescription });

  // This component doesn't render anything, it just manages the document title
  return null;
};
